import React, { useEffect, useState } from "react";

import axios from "axios";



import {

  API_URL,

  getMediaUrl

} from "../config/api";



import {

  CONTENT_TAXONOMY

} from "../config/contentTaxonomy";

import StyledSelect from "../components/StyledSelect";



const getSubcategoryLabel = (subcategory) => {



  if (subcategory === "Science") {

    return "Science & Technology";

  }



  if (

    subcategory === "Cultural" ||

    subcategory === "Culture" ||

    subcategory === "Ink and Echo"

  ) {

    return "Ink & Echo";

  }



  return subcategory;

};



const getCategoryLabel = (category) =>

  category === "Photos & Videos" ||

  category === "PhotosVideos"

    ? "Media"

    : category;



const findTaxonomyNode = (

  nodes,

  value

) => {



  if (!nodes || !value) {

    return null;

  }



  for (

    const [nodeKey, nodeConfig]

    of Object.entries(nodes)

  ) {



    if (

      nodeKey === value ||

      (nodeConfig.legacyValues || [])

        .includes(value)

    ) {



      return {

        key: nodeKey,

        config: nodeConfig

      };



    }



  }



  return null;

};





const getPostSidebarLink = (item) => {



  if (!item) {

    return "/";

  }



  if (item.sidebarLink) {

    return item.sidebarLink;

  }



  const categoryNode =

    findTaxonomyNode(

      CONTENT_TAXONOMY,

      item.category

    );



  if (!categoryNode) {

    return "/";

  }



  let resolvedPath =

    categoryNode.config.path || "/";



  const subcategoryNode =

    findTaxonomyNode(

      categoryNode.config.children,

      item.subcategory

    );



  if (!subcategoryNode) {

    return resolvedPath;

  }



  if (subcategoryNode.config.path) {

    resolvedPath =

      subcategoryNode.config.path;

  }



  const subSubcategoryNode =

    findTaxonomyNode(

      subcategoryNode.config.children,

      item.subSubcategory

    );



  if (!subSubcategoryNode) {

    return resolvedPath;

  }



  if (subSubcategoryNode.config.path) {

    resolvedPath =

      subSubcategoryNode.config.path;

  }



  return resolvedPath;

};





const getSidebarLink = (item) => {



  if (!item) {

    return "/";

  }



  if (item.sidebarType === "publication") {



    return item.sidebarLink || (

      item.type === "book"

        ? "/publications/books"

        : item.type === "newspaper"

          ? "/publications/newspapers"

          : "/publications/magazines"

    );



  }



  return getPostSidebarLink(item);

};



function Magazines({ posts = [], publications = [] }) {



  const [magazines, setMagazines] = useState([]);



  const [selectedYear, setSelectedYear] = useState("");



  const [latestIndex, setLatestIndex] = useState(0);

  const [acrossIndex, setAcrossIndex] = useState(0);



  useEffect(() => {



    axios

      .get(`${API_URL}/api/publications`)

      .then((res) => {



        const onlyMagazines = res.data.filter(

          (item) => item.type === "magazine"

        );



        setMagazines(onlyMagazines);



      })

      .catch((err) => console.log(err));



  }, []);



  const currentYear = new Date().getFullYear();



  const publicationYears = Array.from(

    { length: currentYear - 2020 + 1 },

    (_, index) => 2020 + index

  ).reverse();



  const filteredMagazines = magazines.filter(

    (magazine) =>

      selectedYear === "" ||

      magazine.year?.toString() === selectedYear

  );



  /*

  ============================

  LATEST UPDATES

  ============================

  */



  const publicationUpdates = publications.map(

    (publication) => ({

      ...publication,

      sidebarType: "publication"

    })

  );



  const latestPostUpdates = posts.map(

    (post) => ({

      ...post,

      sidebarType: "post",

      sidebarDate: post.createdAt

        ? new Date(post.createdAt).getTime()

        : 0

    })

  );



  const latestPublicationUpdates =

  publicationUpdates.map(

    (publication) => ({

      ...publication,



      sidebarDate: publication.createdAt

        ? new Date(publication.createdAt).getTime()

        : 0,



      sidebarLink:

        publication.type === "book"

          ? "/publications/books"

          : publication.type === "newspaper"

            ? "/publications/newspapers"

            : "/publications/magazines"

    })

  );



  const latestUpdates = [

    ...latestPostUpdates,

    ...latestPublicationUpdates

  ]

    .sort(

      (a, b) =>

        b.sidebarDate - a.sidebarDate

    )

    .slice(0, 10);



  /*

  ============================

  ACROSS THE SITE

  ============================

  */



  const buildAcrossSiteSections = () => {



    const sections = [];



    Object.entries(CONTENT_TAXONOMY).forEach(

      ([categoryKey, categoryConfig]) => {



        const categoryValues = [

          categoryKey,

          ...(categoryConfig.legacyValues || [])

        ];



        const subcategories =

          categoryConfig.children || {};



        if (

          Object.keys(subcategories).length === 0

        ) {



          sections.push({

            categories: categoryValues

          });



          return;

        }



        Object.entries(subcategories).forEach(

          ([subcategoryKey, subcategoryConfig]) => {



            const subcategoryValues = [

              subcategoryKey,

              ...(subcategoryConfig.legacyValues || [])

            ];



            const subSubcategories =

              subcategoryConfig.children || {};



            if (

              Object.keys(subSubcategories).length === 0

            ) {



              sections.push({

                categories: categoryValues,

                subcategories: subcategoryValues

              });



              return;

            }



            Object.entries(subSubcategories).forEach(

              ([

                subSubcategoryKey,

                subSubcategoryConfig

              ]) => {



                const subSubcategoryValues = [

                  subSubcategoryKey,

                  ...(

                    subSubcategoryConfig.legacyValues ||

                    []

                  )

                ];



                sections.push({

                  categories: categoryValues,

                  subcategories: subcategoryValues,

                  subSubcategories:

                    subSubcategoryValues

                });



              }

            );



          }

        );



      }

    );



    return sections;

  };





  const acrossSiteSections =

    buildAcrossSiteSections();





  const acrossPostItems = acrossSiteSections

    .map((section) => {



      const matchingPosts = posts.filter(

        (post) => {



          const categoryMatch =

            section.categories

              ? section.categories.includes(

                  post.category

                )

              : post.category === section.category;



          const subcategoryMatch =

            section.subcategories

              ? section.subcategories.includes(

                  post.subcategory

                )

              : true;



          const subSubcategoryMatch =

            section.subSubcategories

              ? section.subSubcategories.includes(

                  post.subSubcategory

                )

              : true;



          return (

            categoryMatch &&

            subcategoryMatch &&

            subSubcategoryMatch

          );



        }

      );



      if (matchingPosts.length === 0) {

        return null;

      }



      const latest = [...matchingPosts].sort(

        (a, b) =>

          new Date(b.createdAt) -

          new Date(a.createdAt)

      )[0];



      return {

        ...latest,

        sidebarType: "post",

        sidebarLink: getPostSidebarLink(latest)

      };



    })

    .filter(Boolean);



  const acrossPublicationSections = [

    { type: "book", label: "Publications / Books" },

    { type: "newspaper", label: "Publications / Newspapers" },

    { type: "magazine", label: "Publications / Magazines" }

  ];



  const acrossPublicationItems =

    acrossPublicationSections

      .map((section) => {



        const matchingPublications =

          publicationUpdates

            .filter(

              (publication) =>

                publication.type === section.type

            )

            .sort(

              (a, b) =>

                new Date(b.createdAt) -

                new Date(a.createdAt)

            );



        if (matchingPublications.length === 0) {

          return null;

        }



        const latest =

          matchingPublications[0];



        return {

          ...latest,



          sidebarType: "publication",



          sidebarCategory:

            section.label,



          sidebarLink:

            section.type === "book"

              ? "/publications/books"

              : section.type === "newspaper"

                ? "/publications/newspapers"

                : "/publications/magazines"

        };



      })

      .filter(Boolean);



  const acrossSitePosts = [

    ...acrossPostItems,

    ...acrossPublicationItems

  ];



  /*

  ============================

  AUTO SLIDE

  ============================

  */



  useEffect(() => {



    if (latestUpdates.length <= 1) {

      return;

    }



    const timer = setInterval(() => {



      setLatestIndex(

        (currentIndex) =>

          currentIndex === latestUpdates.length - 1

            ? 0

            : currentIndex + 1

      );



    }, 5000);



    return () => clearInterval(timer);



  }, [latestUpdates.length]);



  useEffect(() => {



    if (acrossSitePosts.length <= 1) {

      return;

    }



    const timer = setInterval(() => {



      setAcrossIndex(

        (currentIndex) =>

          currentIndex === acrossSitePosts.length - 1

            ? 0

            : currentIndex + 1

      );



    }, 5000);



    return () => clearInterval(timer);



  }, [acrossSitePosts.length]);



  /*

  ============================

  PROTECT INDICES

  ============================

  */



  useEffect(() => {



    if (latestUpdates.length === 0) {

      setLatestIndex(0);

      return;

    }



    if (latestIndex >= latestUpdates.length) {

      setLatestIndex(0);

    }



  }, [latestUpdates.length, latestIndex]);



  useEffect(() => {



    if (acrossSitePosts.length === 0) {

      setAcrossIndex(0);

      return;

    }



    if (acrossIndex >= acrossSitePosts.length) {

      setAcrossIndex(0);

    }



  }, [acrossSitePosts.length, acrossIndex]);



  const handlePublicationView = (publicationId) => {



    if (

      localStorage.getItem("isAdmin") === "true"

    ) {

      return;

    }



    axios

      .post(

        `${API_URL}/api/publications/${publicationId}/view`

      )

      .catch((error) => {



        console.error(

          "Error incrementing publication view:",

          error

        );



      });



  };



  return (



    <main className="category-page">



      <div className="category-main-layout">



        {/* =========================

            MAIN Magazines AREA

        ========================== */}



        <section className="category-posts-section">



          <h1>

            Magazines

          </h1>



          {/* YEAR FILTER */}



          <div className="category-controls">



            <StyledSelect
              value={selectedYear}
              ariaLabel="Filter magazines by year"
              className="styled-select--public"
              options={[
                {
                  value: "",
                  label: "All Years"
                },
                ...publicationYears.map(
                  (year) => ({
                    value: String(year),
                    label: String(year)
                  })
                )
              ]}
              onChange={(e) =>
                setSelectedYear(
                  e.target.value
                )
              }
            />



          </div>



          <br />



          {filteredMagazines.length > 0 && (



            <p>

              Results Found:{" "}

              <strong>

                {filteredMagazines.length}

              </strong>

            </p>



          )}



          {filteredMagazines.length === 0 ? (



            <p>

              {selectedYear

                ? "No matching content found."

                : "No content available."}

            </p>



          ) : (



            <div className="category-posts-grid">



              {filteredMagazines.map((magazine) => (



                <div

                  key={magazine._id}

                  className={`category-post-card ${

                    magazine.coverImage ? "has-image" : "no-image"

                  }`}

                  style={

                    magazine.coverImage

                      ? {

                          backgroundImage:

                            `url("${getMediaUrl(magazine.coverImage)}")`,

                        }

                      : {}

                  }

                >



                  {!magazine.coverImage && (

                    <div className="magazine-no-image-icon">

                      📰

                    </div>

                  )}



                  <div className="category-post-overlay">



                    <small>

                      Publications / Magazines

                    </small>



                    <h2>

                      {magazine.title}

                    </h2>



                  <small className="magazine-edition">

                    {magazine.year} Edition

                  </small>



                    <a

                      href={getMediaUrl(magazine.pdf)}

                      target="_blank"

                      rel="noreferrer"

                      onClick={() =>

                        handlePublicationView(magazine._id)

                      }

                    >

                      Open Magazine

                    </a>



                  </div>



                </div>



              ))}



            </div>



          )}



        </section>





        {/* =========================

            SIDEBAR

        ========================== */}



        <aside className="category-sidebar">



          {/* =========================

              LATEST UPDATES

          ========================== */}



          <div className="sidebar-card sidebar-feature-card">



            <h2>

              Latest Updates

            </h2>



            <div className="sidebar-placeholder">



              {latestUpdates.length > 0 ? (



                <>



                  <a

                    href={getSidebarLink(

                      latestUpdates[latestIndex]

                    )}

                    className="sidebar-slide-link"

                  >



                    <div

                      key={`latest-${latestUpdates[latestIndex]._id}-${latestIndex}`}

                      className="sidebar-slide sidebar-feature-slide sidebar-slide-animate"

                      style={{

                        backgroundImage: `url("${

                          latestUpdates[latestIndex].coverImage

                            ? getMediaUrl(

                                latestUpdates[latestIndex].coverImage

                              )

                            : latestUpdates[latestIndex].image

                              ? getMediaUrl(

                                  latestUpdates[latestIndex].image

                                )

                              : "/default-cover.jpg"

                        }")`

                      }}

                    >



                      <div className="sidebar-feature-overlay">



                        <div className="sidebar-feature-content">



                          {/* CATEGORY / TYPE */}



                          <small className="sidebar-feature-category">



                            {latestUpdates[latestIndex].sidebarType ===

                            "publication"

                              ? (

                                  latestUpdates[latestIndex].type === "book"

                                    ? "Publications / Books"

                                    : latestUpdates[latestIndex].type === "newspaper"

                                      ? "Publications / Newspapers"

                                      : "Publications / Magazines"

                                )

                              : (

                                  <>

                                    {getCategoryLabel(

                                      latestUpdates[latestIndex].category

                                    )}



                                    {latestUpdates[latestIndex].subcategory && (

                                      <>

                                        {" / "}

                                        {getSubcategoryLabel(

                                          latestUpdates[latestIndex].subcategory

                                        )}

                                      </>

                                    )}



                                    {latestUpdates[latestIndex].subSubcategory && (

                                      <>

                                        {" / "}

                                        {latestUpdates[latestIndex].subSubcategory}

                                      </>

                                    )}

                                  </>

                                )}



                          </small>



                          {/* TITLE */}



                          <h3>

                            {latestUpdates[latestIndex].title}

                          </h3>



                          {/* PUBLICATION DESCRIPTION */}



                          {latestUpdates[latestIndex].sidebarType ===

                            "publication" &&

                            latestUpdates[latestIndex].description && (



                              <p className="sidebar-feature-description">

                                {latestUpdates[latestIndex].description.substring(0, 120)}

                                {latestUpdates[latestIndex].description.length > 120

                                  ? "..."

                                  : ""}

                              </p>



                          )}



                          {/* PUBLICATION AUTHOR */}



                          {latestUpdates[latestIndex].sidebarType ===

                            "publication" &&

                            latestUpdates[latestIndex].author && (



                              <p className="sidebar-feature-author">

                                By {latestUpdates[latestIndex].author}

                              </p>



                          )}



                          {/* POST AUTHOR */}



                          {latestUpdates[latestIndex].sidebarType !==

                            "publication" &&

                            latestUpdates[latestIndex].writer && (



                              <p className="sidebar-feature-author">

                                By {latestUpdates[latestIndex].writer}

                              </p>



                          )}



                        </div>



                      </div>



                    </div>



                  </a>



                  {/* NAVIGATION */}



                  <div className="sidebar-navigation">



                    <button

                      type="button"

                      onClick={() =>

                        setLatestIndex(

                          latestIndex === 0

                            ? latestUpdates.length - 1

                            : latestIndex - 1

                        )

                      }

                    >

                      ←

                    </button>



                    <div className="homepage-sidebar-progress">



  <div

    className="homepage-sidebar-dots"

    aria-label="Latest Updates slides"

  >



    {latestUpdates.map(

      (item, indicatorIndex) => (



        <button

          key={

            `latest-indicator-${

              item._id || indicatorIndex

            }-${indicatorIndex}`

          }

          type="button"

          className={

            [

              "homepage-sidebar-dot",

              latestIndex === indicatorIndex

                ? "active"

                : ""

            ]

              .filter(Boolean)

              .join(" ")

          }

          aria-label={

            `Show Latest Update ${

              indicatorIndex + 1

            }`

          }

          aria-current={

            latestIndex === indicatorIndex

              ? "true"

              : undefined

          }

          onClick={() =>

            setLatestIndex(

              indicatorIndex

            )

          }

        />



      )

    )}



  </div>



</div>



                    <button

                      type="button"

                      onClick={() =>

                        setLatestIndex(

                          latestIndex === latestUpdates.length - 1

                            ? 0

                            : latestIndex + 1

                        )

                      }

                    >

                      →

                    </button>



                  </div>



                </>



              ) : (



                <p>

                  No latest updates available.

                </p>



              )}



            </div>



          </div>





          {/* =========================

              ACROSS THE SITE

          ========================== */}



          <div className="sidebar-card sidebar-feature-card">



            <h2>

              Across the Site

            </h2>



            <div className="sidebar-placeholder">



              {acrossSitePosts.length > 0 ? (



                <>



                  <a

                    href={getSidebarLink(

                      acrossSitePosts[acrossIndex]

                    )}

                    className="sidebar-slide-link"

                  >



                    <div

                      key={`across-${acrossSitePosts[acrossIndex]._id}-${acrossIndex}`}

                      className="sidebar-slide sidebar-feature-slide sidebar-slide-animate"

                      style={{

                        backgroundImage: `url("${

                          acrossSitePosts[acrossIndex].coverImage

                            ? getMediaUrl(

                                acrossSitePosts[acrossIndex].coverImage

                              )

                            : acrossSitePosts[acrossIndex].image

                              ? getMediaUrl(

                                  acrossSitePosts[acrossIndex].image

                                )

                              : "/default-cover.jpg"

                        }")`

                      }}

                    >



                      <div className="sidebar-feature-overlay">



                        <div className="sidebar-feature-content">



                          {/* CATEGORY / TYPE */}



                          <small className="sidebar-feature-category">



                            {acrossSitePosts[acrossIndex].sidebarType ===

                            "publication"

                              ? (

                                  acrossSitePosts[acrossIndex].sidebarCategory ||

                                  (

                                    acrossSitePosts[acrossIndex].type === "book"

                                      ? "Publications / Books"

                                      : acrossSitePosts[acrossIndex].type === "newspaper"

                                        ? "Publications / Newspapers"

                                        : "Publications / Magazines"

                                  )

                                )

                              : (

                                  <>

                                    {getCategoryLabel(

                                      acrossSitePosts[acrossIndex].category

                                    )}



                                    {acrossSitePosts[acrossIndex].subcategory && (

                                      <>

                                        {" / "}

                                        {getSubcategoryLabel(

                                          acrossSitePosts[acrossIndex].subcategory

                                        )}

                                      </>

                                    )}



                                    {acrossSitePosts[acrossIndex].subSubcategory && (

                                      <>

                                        {" / "}

                                        {acrossSitePosts[acrossIndex].subSubcategory}

                                      </>

                                    )}

                                  </>

                                )}



                          </small>



                          {/* TITLE */}



                          <h3>

                            {acrossSitePosts[acrossIndex].title}

                          </h3>



                          {/* PUBLICATION DESCRIPTION */}



                          {acrossSitePosts[acrossIndex].sidebarType ===

                            "publication" &&

                            acrossSitePosts[acrossIndex].description && (



                              <p className="sidebar-feature-description">

                                {acrossSitePosts[acrossIndex].description.substring(0, 120)}

                                {acrossSitePosts[acrossIndex].description.length > 120

                                  ? "..."

                                  : ""}

                              </p>



                          )}



                          {/* PUBLICATION AUTHOR */}



                          {acrossSitePosts[acrossIndex].sidebarType ===

                            "publication" &&

                            acrossSitePosts[acrossIndex].author && (



                              <p className="sidebar-feature-author">

                                By {acrossSitePosts[acrossIndex].author}

                              </p>



                          )}



                          {/* POST AUTHOR */}



                          {acrossSitePosts[acrossIndex].sidebarType !==

                            "publication" &&

                            acrossSitePosts[acrossIndex].writer && (



                              <p className="sidebar-feature-author">

                                By {acrossSitePosts[acrossIndex].writer}

                              </p>



                          )}



                        </div>



                      </div>



                    </div>



                  </a>



                  {/* NAVIGATION */}



                  <div className="sidebar-navigation">



                    <button

                      type="button"

                      onClick={() =>

                        setAcrossIndex(

                          acrossIndex === 0

                            ? acrossSitePosts.length - 1

                            : acrossIndex - 1

                        )

                      }

                    >

                      ←

                    </button>



                    <div className="homepage-sidebar-progress">



  <div

    className="homepage-sidebar-dots"

    aria-label="Across the Site slides"

  >



    {acrossSitePosts.map(

      (item, indicatorIndex) => (



        <button

          key={

            `across-indicator-${

              item._id || indicatorIndex

            }-${indicatorIndex}`

          }

          type="button"

          className={

            [

              "homepage-sidebar-dot",

              acrossIndex === indicatorIndex

                ? "active"

                : ""

            ]

              .filter(Boolean)

              .join(" ")

          }

          aria-label={

            `Show Across the Site item ${

              indicatorIndex + 1

            }`

          }

          aria-current={

            acrossIndex === indicatorIndex

              ? "true"

              : undefined

          }

          onClick={() =>

            setAcrossIndex(

              indicatorIndex

            )

          }

        />



      )

    )}



  </div>



</div>



                    <button

                      type="button"

                      onClick={() =>

                        setAcrossIndex(

                          acrossIndex === acrossSitePosts.length - 1

                            ? 0

                            : acrossIndex + 1

                        )

                      }

                    >

                      →

                    </button>



                  </div>



                </>



              ) : (



                <p>

                  No content available.

                </p>



              )}



            </div>



          </div>



        </aside>



      </div>



    </main>



  );

}



export default Magazines;
